import React from 'react';

import {createMaterialBottomTabNavigator} from 'react-native-paper/react-navigation';

import Ionicons from 'react-native-vector-icons/Ionicons';

import {SafeAreaInsetsContext} from 'react-native-safe-area-context';
import {createDrawerNavigator} from '@react-navigation/drawer';
import CustomNavigationBar from './nav/appnav';

import {createFileStack} from '../navigators/filestack';
import {Platform, useWindowDimensions} from 'react-native';
import DrawerItems from './nav/drawer';
import {createChatStack} from '../navigators/chatstack';
import {createSettings} from '../navigators/settings';
import {createEncoder} from '../navigators/encoder';
import {createEditor} from '../navigators/editor';
import {createNativeStackNavigator} from '@react-navigation/native-stack';
import {useAppDispatch, useAppSelector} from '../store/hooks';
import {setCurrentPage} from '../store/slices/ui';
// import {useKeyboardDispatcher} from '../hooks/useKeyboardListener';
import {
  ExtendedNavState,
  StackRouteName,
  UnifiedStackParam,
  RootStackName,
  RootStackRouteNames,
} from '../types/nav';
import {createShopStack} from '../navigators/shopstack';
import {useQuery} from 'react-query';
import {
  checkServiceValid,
  getShopServiceAddress,
} from '../api/exchange';

const DrawerNav = createDrawerNavigator();

const Tab = createMaterialBottomTabNavigator();

const RootStack = createNativeStackNavigator();

const FileStack = createFileStack();

const ChatStackScreen = createChatStack();

const SettingsStack = createSettings();

const EncoderStack = createEncoder();

const EditorStack = createEditor();

const ShopStack = createShopStack();

const TabNav = () => {
  const dim = useWindowDimensions();
  const dispatch = useAppDispatch();
  const isNavHidden = useAppSelector(
    state => state.ui.isTabBarHidden,
  );
  const screenStateListener = (navState: ExtendedNavState) => {
    try {
      const currentTab =
        navState?.data?.state?.routes[
          navState?.data.state?.index || 0
        ] || {};
      const currentNavPage =
        currentTab?.state?.routes[currentTab?.state?.index || 0];
      const parentName = currentTab.name as RootStackRouteNames;
      const currentPage = currentNavPage?.name as StackRouteName;
      const params = currentNavPage?.params as UnifiedStackParam;
      dispatch(setCurrentPage({currentPage, params, parentName}));
    } catch (err) {}
  };

  const isKioskEnabledQuery = useQuery(
    'drawerItems',
    async () => {
      try {
        let isKioskEnabled = false;
        try {
          if (Platform.OS === 'web') {
            const shopAddress = await getShopServiceAddress();
            isKioskEnabled = await checkServiceValid(shopAddress);
          }
        } catch (err) {
          console.error(err);
        }
        if (isKioskEnabled) {
          return true;
        }
      } catch (err) {
        console.error('isKioskEnabled err', err);
      }

      return false;
    },
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchInterval: 15000,
    },
  );
  if (dim.width > 700 && Platform.OS === 'web') {
    return (
      <SafeAreaInsetsContext.Consumer>
        {insets => {
          const {left, right} = insets || {left: 0, right: 0};
          const collapsedDrawerWidth = 80 + Math.max(left, right);
          const nonCollasedWidth = 180;
          const collapsed = true;
          return (
            <DrawerNav.Navigator
              screenOptions={{
                drawerStyle: {
                  width: collapsed
                    ? collapsedDrawerWidth
                    : nonCollasedWidth,
                },
                drawerPosition: 'left',
                drawerType: 'permanent',
              }}
              detachInactiveScreens={true}
              defaultStatus="open"
              screenListeners={{
                state: state =>
                  screenStateListener(state as ExtendedNavState),
              }}
              drawerContent={props => <DrawerItems {...props} />}>
              <DrawerNav.Screen
                name="FilesTab"
                component={FileStack}
                options={{
                  headerShown: false,
                  drawerIcon: ({color, size}) => (
                    <Ionicons
                      name="folder-outline"
                      color={color}
                      size={24}
                    />
                  ),
                  title: 'Files',
                }}
              />
              <DrawerNav.Screen
                name="ContactsTab"
                component={ChatStackScreen}
                options={{
                  headerShown: false,
                  title: 'Contacts',
                }}
              />
              {/* <DrawerNav.Screen
                name="EncoderTab"
                component={EncoderStack}
                options={{
                  headerShown: false,
                  title: 'Encoder',
                }}
              /> */}
              <DrawerNav.Screen
                name="EditorTab"
                component={EditorStack}
                options={{
                  headerShown: false,
                  title: 'Editor',
                }}
              />
              <DrawerNav.Screen
                name="SettingsTab"
                component={SettingsStack}
                options={{
                  headerShown: false,
                  drawerIcon: ({color, size}) => (
                    <Ionicons
                      name="people-outline"
                      color={color}
                      size={24}
                    />
                  ),
                  title: 'Contacts',
                }}
              />
              <DrawerNav.Screen
                name="ShopTab"
                component={ShopStack}
                options={{
                  headerShown: false,
                  title: 'Shop',
                }}
              />
            </DrawerNav.Navigator>
          );
        }}
      </SafeAreaInsetsContext.Consumer>
    );
  }
  return (
    <Tab.Navigator
      barStyle={{display: isNavHidden ? 'none' : 'flex'}}
      screenListeners={{
        state: state =>
          screenStateListener(state as ExtendedNavState),
      }}>
      <Tab.Screen
        name="FilesTab"
        options={{
          tabBarLabel: 'Files',
          tabBarIcon: 'folder',
        }}
        component={FileStack}
      />
      <Tab.Screen
        name="ContactsTab"
        component={ChatStackScreen}
        options={{
          tabBarLabel: 'Chat',
          tabBarIcon: 'forum',
        }}
      />
      <Tab.Screen
        name="EditorTab"
        component={EditorStack}
        options={{
          tabBarLabel: 'Editor',
          tabBarIcon: 'scissors-cutting',
        }}
      />
      <Tab.Screen
        name="SettingsTab"
        options={{
          tabBarLabel: 'Settings',
          tabBarIcon: 'cog',
        }}
        component={SettingsStack}
      />
      {isKioskEnabledQuery.data === true && (
        <Tab.Screen
          name="ShopTab"
          component={ShopStack}
          options={{
            tabBarLabel: 'Shop',
            tabBarIcon: 'cart',
          }}
        />
      )}
    </Tab.Navigator>
  );
};

const RootStackNav = () => (
  <RootStack.Navigator
    screenOptions={{
      header: props => <CustomNavigationBar {...props} />,
    }}>
    <RootStack.Screen
      name={RootStackName}
      component={TabNav}
      options={{
        orientation: 'portrait',
        freezeOnBlur: true,
      }}
    />
  </RootStack.Navigator>
);

export default RootStackNav;
